var mentions_default = {
  "mention": "PGxUW",
  "mentionViewer": "ZYQpr",
  "cursorDefault": "OSbOt",
  "cursorPointer": "Xo6L2"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
